export const postalCodeLength = {
    "TW": 6,
    "SG": 6,
    "US": 5,
    "JP": 7
}
export const destinationCountries =
[
  {
    "key" : "JP",
    "value": "Japan"
  },
  {
    "key" : "HK",
    "value" : "Hong Kong"
  },
  {
    "key" : "TW",
    "value" : "Taiwan"
  },
  {
    "key": "US",
    "value": "United States",
  },
  {
    "key": "SG",
    "value": "Singapore"
  }
];


// WEBPACK FOOTER //
// ./src/services/constant.js